import React, { useEffect, useState } from "react";
import Header from "./Header";
import LeftNavbar from "../global/LeftNavbar";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import DataTable from "react-data-table-component";
import { AdvanceSearchParamsIcon } from "../../AppIcons";
import FilterProject from "./FinanceFilter";
import AdvanceFilter from "./FinanceAdvanceFilter";
import Constants from "../../Constants";
import DateFormat from "../../pages/DateFormat";
import { RotatingLines } from "react-loader-spinner";
import { ConditionalBlock } from "../../ConditionalBlock";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Import  from "./ImportBulkProject";
import { useTranslation } from "react-i18next";
import dateUtil from "../../services/DateUtil";

export default function FinanceProjects(prop) {

  const [data, updateList] = useState([]);
  const [searchText, setSearchText] = useState();
  const [accountNameFilter, setAccountNameFilter] = useState();
  const [dateFilter, setDateFilter] = useState();
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false);
  const [searchAdFilters, updateSearchAdFilters] = useState({});
  const [sortParam, setSortParam] = useState();
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [showBulkImport, setShowBulkImport] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { t } = useTranslation();
  const { state } = useLocation();
  const [retainFilter, setRetainFilter] = useState(state?state.retainFilter:false);
  

  // Define columns for DataTable
  const columns = [
    {
      id: "name",
      name: 'Project Name', selector: row => row.projectName,
      cell: (row) => (
        <Link
          style={{
            color: aaaSelected ? "#FFF" : "#4067D6",
            fontWeight: 500,
            position: "relative",
          }}
          to={`/finance/project/${row.projectId}`}
        >
          {row.projectName}
        </Link>
      )
    },
    {  id: "closedOn", name: 'Closed On', selector: row => <DateFormat date={row.projectStatus === Constants.PROJECT_CLOSED ? row.closedOn : row.billingInclusionDate} />, sortable: true },
    {  id: "sp", name: 'Service Provider', selector: row => row.serviceProvider},
    {  id: "status", name: 'Project Status', selector: row => row.projectStatus },
    {  id: "invoicestatus", name: 'Subscriber Invoice Status', selector: row => row.subscriberInvoiceStatus},
    {  id: "spInvocieStatus", name: 'Service Provider Invoice Status', selector: row => row.serviceProviderInvoiceStatus},
    {  id: "projectId", name: 'Project Id', selector: row => row.projectId, sortable: true }, 
  ];

  useEffect(() => {
    if (accountNameFilter && dateFilter) {
      let queryParams = new URLSearchParams();
  
      if (accountNameFilter) queryParams.append('accountId', accountNameFilter);
      if (searchText) queryParams.append('projectName', searchText);
      
      if (searchAdFilters?.Project_ID) {
        queryParams.append('projectId', searchAdFilters.Project_ID);
      }
      if (searchAdFilters?.Subscriber_Invoice_Status) queryParams.append('subscriberInvoiceStatus', searchAdFilters.Subscriber_Invoice_Status.value);
      if (searchAdFilters?.Service_Provider_Invoice_Status) queryParams.append('serviceProviderInvoiceStatus', searchAdFilters.Service_Provider_Invoice_Status.value);
      if (searchAdFilters?.Service_Provider) queryParams.append('serviceProvider', searchAdFilters.Service_Provider.value);

      if(searchAdFilters?.Project_Status) {
        queryParams.append('projectStatus', searchAdFilters.Project_Status.value);
      }
  
      if (dateFilter) {
        let startDate = dateUtil.getPSTStartOfDay(dateFilter[0]);
        let endDate = dateUtil.getPSTEndOfDay(dateFilter[1]);
        queryParams.append('startDate', startDate);
        queryParams.append('endDate', endDate);
      }
  
      if (sortParam) {
        const sortParams = new URLSearchParams(sortParam);
        sortParams.forEach((value, key) => {
          queryParams.append(key, value);
        });
      }
  
      queryParams.append('pageNumber', currentPage);
      queryParams.append('rowsPerPage', rowsPerPage);
  
      const queryString = queryParams.toString();
  
      getAxiosResponse(`${APIUrls.PROJECT_LIST_FINANCE}?${queryString}`)
        .then((res) => {
          if (res.data !== "") {
            updateList(res.data.data.projectData);
            setTotalRows(res.data.data.projectCount);
            setLoading(false);
          }
        }).catch((err) => {
          console.error(err);
        });
    }
  }, [accountNameFilter, searchAdFilters, searchText, dateFilter, currentPage, rowsPerPage, sortParam]);



  const handlePageChange = (paging) => {
    setCurrentPage(paging);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    if (!data.length) return;
    setRowsPerPage(newRowsPerPage);
  };

  useEffect(() => {
    if (showAdvanceFilter) {
      document.body.classList.add("modal-open");
    }
    else {
      document.body.classList.remove("modal-open");
    }
  }, [showAdvanceFilter]);

  const closeRightModal = () => {
    setShowAdvanceFilter(false)
  }

  useEffect(() => {
    if (showSuccess) {
      setTimeout(() => {
        setShowSuccess(false);
      }, 2000);
    }
  }, [showSuccess]);

  function removeFilter(removableLabel) {

    switch (removableLabel) {
      case 'Service_Provider':
        delete searchAdFilters.Service_Provider;
        break;
      case 'Project_Status':
        delete searchAdFilters.Project_Status;
        break;
      case 'Subscriber_Invoice_Status':
        delete searchAdFilters.Subscriber_Invoice_Status;
        break;
      case 'Project_ID':
        delete searchAdFilters.Project_ID;
        break;
      case 'Service_Provider_Invoice_Status':
        delete searchAdFilters.Service_Provider_Invoice_Status;
        break;
      default:
        break;
    }
    const newFilters = { ...searchAdFilters };

    updateSearchAdFilters(newFilters);
  }

  const handleSort = async (column, sortDirection) => {
    var order = sortDirection.toUpperCase();
    var sortedColumn = column.id;
    var sortedString = `sortOrder=${order}&sortColumn=${sortedColumn}`;
    setSortParam(sortedString);
  };

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
      </div>
    );
  }



  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header />
        <LeftNavbar />
        <section className="dashboard-content">
          <div id="content" className="dashboard-wrap campaign-section">
            <div>&nbsp;</div>
            <ConditionalBlock condition={showBulkImport}>
              <Import setShowBulkImport={setShowBulkImport} setShowSuccess={setShowSuccess} setRetainFilter={setRetainFilter} />
            </ConditionalBlock>
            <ConditionalBlock condition={!showBulkImport}>
              <>
                <FilterProject retainFilter={retainFilter} showProjectNameFilter={true} showDownloadReport={false} setShowAdvanceFilter={setShowAdvanceFilter} setSearchText={setSearchText} setAccountNameFilter={setAccountNameFilter} setDateFilter={setDateFilter}
                  setShowBulkImport={setShowBulkImport} requestFromProject={true}/>
                <div className="white-bg">
                  <div className="campaign-hedaing flex justify-center">
                    <ul className="selected-data flex">
                      {Object.entries(searchAdFilters).map(([label, value]) => {
                        if (value.label?.length !== 0 && value.label !== Constants.SELECT) {
                          return (
                            <li key={label}>
                              <button onClick={(e) => { removeFilter(label) }}>
                                <p aria-label={`Remove : ${value.label}`} >
                                  <small>{label.replaceAll("_", " ")} : </small> {label !== "Project_ID" ? value.label : value}
                                </p>
                                <span>
                                  {AdvanceSearchParamsIcon}
                                </span>
                              </button>
                            </li>
                          );
                        }
                      })}

                    </ul>
                  </div>
                  <div className="datatable-block">
                    <DataTable
                      columns={columns}
                      data={data}
                      striped={true}
                      sortServer
                      onSort={handleSort}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handleRowsPerPageChange}
                      noDataComponent={noDataFoundComponent()}
                    />
                  </div>
                </div>
              </>
            </ConditionalBlock>
          </div>
        </section>

        <div className="overlay" onClick={closeRightModal}></div>
        <ConditionalBlock condition={loading}>
          <div className={"gb-overlay show"}>
            <div className="gb-loader">
              <RotatingLines
                strokeColor="#0096FF"
                strokeWidth="5"
                width="196"
                visible={true}
              />
            </div>
          </div>
        </ConditionalBlock>
        <div className={"success-message" + (showSuccess === true ? " show" : " hide")} id="show-success" role="alert">
          {`${t('settings_user_management_bulk_users_upload_success')}`}
        </div>
        <ConditionalBlock condition={showAdvanceFilter}>
          <AdvanceFilter setShowAdvanceFilter={setShowAdvanceFilter} updateSearchAdFilters={updateSearchAdFilters} searchAdFilters={searchAdFilters} reportsAdvanceFilter={false} accountId={accountNameFilter} />
        </ConditionalBlock>
      </div>

    </div>
  );
};